/**
 * Page is only accessible if user is authenticated.
 */

import AppApi from '@api/AppApi';

export default function({ to, from, store }) {
    // Get vars.
    let apiKey = store.getters.apiKey;
    let user = store.getters.user;
    let project = store.getters.project;

    // Not authenticated. Redirect to login page.
    if (to.name !== 'login' && !apiKey) {
        return { name: 'login', query: { redirect: to.fullPath } };
    }

    // No project. Prompt for project setup.
    if (to.name !== 'project-setup' && user && !project) {
        return { name: 'project-setup' };
    }

    // No user. Boot app and redirect.
    if (!user) {
        return AppApi.getApp().then(() => {
            return to;
        }, (error) => {
            console.error('Error booting the app:', error);
            // This should not fail, but redirect to login if it does.
            store.commit('logout');
            return { name: 'login' };
        });
    }
}
